import { ACCESSORIES_MANAGEMENT } from '@/libs/fakeData'

export const state = () => ({
  list: [],
  selected: []
})

export const getters = {
  list (state) {
    return state.list
  },
  selected (state) {
    return state.selected
  }
}

export const actions = {
  async fetch ({ commit }) {
    const data = ACCESSORIES_MANAGEMENT
    // api
    commit('SET_LIST', data)
  },
  async updateSelected ({ commit }, selected) {
    commit('SET_SELECTED', selected)
  },
  async deleteBikes ({ commit }) {
    // api
  }
}

export const mutations = {
  SET_LIST (state, value) {
    state.list = value
  },
  SET_SELECTED (state, value) {
    state.selected = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
